import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'

import { products} from '../../../actions'

class Products extends Component{
  componentDidMount(){
    this.props.checkIfAuthenticated()
    this.props.fetchProducts()
  }

  render() {
    return(
      <div className="Products">
        <h1>Products</h1>
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th>Artikel nr</th>
                <th>Titel</th>
                <th>Pris</th>
                <th>Packet</th>
                <th>Redigera</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.products.map(item => {
                  return(
                    <tr key={item.id}>
                      <td>{item.article_number}</td>
                      <td>{item.title}</td>
                      <td>{item.price}kr</td>
                      <td>{item.packet}</td>
                      <td>
                        <Link
                          to={`/backoffice/products/${item.id}`}
                          className="table-button">
                          Ändra
                        </Link>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    products: state.products
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchProducts: () => {
      return dispatch(products.fetchProducts());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Products.jsx